/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdvertisingPackageRequest,
  AdvertisingPackageRequestDataWithFiles,
  AdvertisingPackageResponse,
  AdvertisingPackageTimelineRequest,
  AdvertisingPackageTimelineResponse,
  PageResponseAdvertisingPackageResponse,
  SupportPictureResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdvertisingPackages<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name AddAdvertisingPackage
   * @request POST:/advertisingPackages
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  addAdvertisingPackage = (
    data: AdvertisingPackageRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name GetAdvertisingPackagesTimeline
   * @summary Advertising package occupancy timeline
   * @request POST:/advertisingPackages/timeline
   * @secure
   * @response `200` `AdvertisingPackageTimelineResponse` OK
   */
  getAdvertisingPackagesTimeline = (
    data: AdvertisingPackageTimelineRequest,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageTimelineResponse, any>({
      path: `/advertisingPackages/timeline`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name ListAdvertisingPackages
   * @request POST:/advertisingPackages/getAdvertisingPackages
   * @secure
   * @response `200` `PageResponseAdvertisingPackageResponse` OK
   */
  listAdvertisingPackages = (
    data: AdvertisingPackageRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseAdvertisingPackageResponse, any>({
      path: `/advertisingPackages/getAdvertisingPackages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name AddAdvertisingPackageDraft
   * @request POST:/advertisingPackages/drafts
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  addAdvertisingPackageDraft = (
    data: AdvertisingPackageRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/drafts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name CountAdvertisingPackages
   * @request POST:/advertisingPackages/count
   * @secure
   * @response `200` `number` OK
   */
  countAdvertisingPackages = (
    data: AdvertisingPackageRequest,
    params: RequestParams = {},
  ) =>
    this.request<number, any>({
      path: `/advertisingPackages/count`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name ShowAdvertisingPackage
   * @request GET:/advertisingPackages/{advertisingPackageId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  showAdvertisingPackage = (
    advertisingPackageId: string,
    query?: {
      /** @format date-time */
      start?: string;
      /** @format date-time */
      end?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/${advertisingPackageId}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DeleteAdvertisingPackage
   * @request DELETE:/advertisingPackages/{advertisingPackageId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  deleteAdvertisingPackage = (
    advertisingPackageId: string,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/${advertisingPackageId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name UpdateAdvertisingPackage
   * @request PATCH:/advertisingPackages/{advertisingPackageId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  updateAdvertisingPackage = (
    advertisingPackageId: string,
    data: AdvertisingPackageRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/${advertisingPackageId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DeleteAdvertisingPackageDraft
   * @request DELETE:/advertisingPackages/drafts/{advertisingPackageId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  deleteAdvertisingPackageDraft = (
    advertisingPackageId: string,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/drafts/${advertisingPackageId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name UpdateAdvertisingPackageDraft
   * @request PATCH:/advertisingPackages/drafts/{advertisingPackageId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  updateAdvertisingPackageDraft = (
    advertisingPackageId: string,
    data: AdvertisingPackageRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/drafts/${advertisingPackageId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name GetSupportPictures1
   * @request GET:/advertisingPackages/{advertisingPackageId}/supportPictures
   * @secure
   * @response `200` `SupportPictureResponse` OK
   */
  getSupportPictures1 = (
    advertisingPackageId: string,
    params: RequestParams = {},
  ) =>
    this.request<SupportPictureResponse, any>({
      path: `/advertisingPackages/${advertisingPackageId}/supportPictures`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DownloadPackageSupportPictures
   * @summary Download Advertising Package Support Pictures
   * @request GET:/advertisingPackages/{advertisingPackageId}/supportPictures/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadPackageSupportPictures = (
    advertisingPackageId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/advertisingPackages/${advertisingPackageId}/supportPictures/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DownloadAdvertisingPackageDocuments
   * @summary Download Advertising Package Documents
   * @request GET:/advertisingPackages/{advertisingPackageId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadAdvertisingPackageDocuments = (
    advertisingPackageId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/advertisingPackages/${advertisingPackageId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DownloadAdvertisingPackageDocument
   * @summary Download Advertising Package Document
   * @request GET:/advertisingPackages/{advertisingPackageId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadAdvertisingPackageDocument = (
    advertisingPackageId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/advertisingPackages/${advertisingPackageId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name DeleteAdvertisingPackageDocument
   * @summary Delete Advertising Package Document
   * @request DELETE:/advertisingPackages/{advertisingPackageId}/documents/{documentId}
   * @secure
   * @response `200` `AdvertisingPackageResponse` OK
   */
  deleteAdvertisingPackageDocument = (
    advertisingPackageId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse, any>({
      path: `/advertisingPackages/${advertisingPackageId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description DEPRECATED FORM — the endpoint stays, the windowless call does not. Omitting the window answers free days over the inventory's whole lifetime, which reads the past without passing the past-window gate. Send the window: it is optional today for backward compatibility and becomes MANDATORY in the next release. A window that starts in the past is refused with 403 to ADVERTISER and SERVICES callers who do not hold permission:global:create:past-bookings.
   *
   * @tags advertising-package-controller
   * @name GetAdvertisingPackageAvailabilityResource
   * @summary Advertising package availability days
   * @request GET:/advertisingPackages/{advertisingPackageId}/availability
   * @deprecated
   * @secure
   * @response `200` `(string)[]` OK
   */
  getAdvertisingPackageAvailabilityResource = (
    advertisingPackageId: string,
    query?: {
      /**
       * Optional today, MANDATORY from the next release. Supplied windows are gated: a past-dated start needs permission:global:create:past-bookings unless the caller is LOCATION or BACKOFFICE.
       * @format date-time
       */
      start?: string;
      /**
       * Optional today, MANDATORY from the next release. Supplied windows are gated: a past-dated start needs permission:global:create:past-bookings unless the caller is LOCATION or BACKOFFICE.
       * @format date-time
       */
      end?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], any>({
      path: `/advertisingPackages/${advertisingPackageId}/availability`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertising-package-controller
   * @name GetPackagesForSpace
   * @request GET:/advertisingPackages/spaces/{spaceId}
   * @secure
   * @response `200` `(AdvertisingPackageResponse)[]` OK
   */
  getPackagesForSpace = (
    spaceId: string,
    query?: {
      /** @format date-time */
      start?: string;
      /** @format date-time */
      end?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AdvertisingPackageResponse[], any>({
      path: `/advertisingPackages/spaces/${spaceId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
